import {environment} from "environments";

(() => {
  class PrescriptionEditorController {
    constructor($scope, toastr, Constants, Orders, MedicationService, Utils, Pharmacy, Services) {
      'ngInject';

      Object.assign(this, {
        $scope,
        Constants,
        toastr,
        Orders,
        MedicationService,
        Math,
        Utils,
        Pharmacy,
        DosespotDispenseUnits: Constants.DosespotDispenseUnits,
        Services,
        detailsHidden: true,
        BOD_363: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_2262: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
      });
    }

    $onInit() {
      this.defaults = {
        dispense_amount: '',
        days_supply: '',
        num_refills: '',
        short_directions: '',
        pharmacy_notes: '',
        no_substitutions: false,
      };

      // Strip out default_, will be reattached when setting as default
      Object.keys(this.medication).forEach((oldKey) => {
        const newKey = oldKey.replace('default_', '');
        if (oldKey.indexOf('default_') > -1) {
          this.medication[newKey] = this.medication[oldKey];
          delete this.medication[oldKey];
        }

        const value = this.medication[newKey];

        if (newKey in this.defaults && (!value || value === undefined || value === null)) {
          this.medication[newKey] = this.defaults[newKey];
        }
      });

      this.medication.num_refills = this.medication.num_refills || 0;

      if (this.medication.dosespot_medication) {
        this.dosespotMedication = this.medication.dosespot_medication;
      }

      this.Services.getCachedPimsParameters()
        .then(({ pimsVisitParameters }) => {
          this.parameters = pimsVisitParameters;
          this.$scope.$apply(() => {
            this.detailsHidden = !this.parameters.prescribe_editor_expanded_list
              .includes(this.service.code);
          });
        });
    }

    formatDispenseAmount() {
      const { dispense_amount: amount } = this.medication;

      // get both sides of the decimal place... if there is one
      let [leftSide = '', rightSide = ''] = amount.split('.');

      // empty values, bail out
      if (!leftSide.length && !rightSide.length) {
        return;
      }

      // strip leading and trailing zeros
      leftSide = leftSide.replace(/^[0]+/g, '');
      rightSide = rightSide.replace(/[0]+$/g, '');

      // Prepend decimal with a zero if no left side, e.g .123
      if (!leftSide.length && rightSide.length) {
        this.medication.dispense_amount = `0.${rightSide}`;
        return;
      }

      this.medication.dispense_amount = `${leftSide}${rightSide.length ? `.${rightSide}` : ''}`;
    }

    getDosespotDrugName() {
      const { dosespot_medication: dm } = this.medication;

      if (!dm) {
        return false;
      }

      const drugName = dm.matched_drug_name.split(' (')[0];

      return `${drugName} ${dm.strength_description} ${dm.dose_form_description}`;
    }

    resetMedication() {
      this.medication = Object.assign({}, this.medication, this.defaults);
    }

    /**
     * Determines if prescription has been saved to orderline
     * @return {boolean} t/f
     */
    hasPrescriptionBeenSaved() {
      return this.medication.saved;
    }

    /**
     * Determines if prescription has been sent to pharmacy
     * @return {boolean} t/f
     */
    hasPrescriptionBeenSent() {
      return this.medication.sent;
    }

    /**
     * Determines if this prescription is active or not
     * @return {boolean} prescription is active
     */
    isPrescriptionActive() {

      if (!this.medication.sent) {
        return false;
      }

      var days_supply = parseInt(this.medication.days_supply);
      var sentAt = moment(this.medication.sent);
      var inactiveAt = sentAt.clone().add(days_supply, 'days');
      var now = moment(new Date());

      //console.log(sentAt);
      //console.log(inactiveAt);
      //console.log(now);

      return now.isBetween(sentAt, inactiveAt);
    }

    isPrescriptionSaved() {
      return this.medication.saved;
    }

    getCharacterCount(max = 0, string) {
      if (string === undefined) return 0;

      let stringLength;
      if (string && string.length) {
        stringLength = string.length;
      } else {
        stringLength = 0;
      }

      let charsLeft = max - stringLength;
      charsLeft = charsLeft < 0 ? 0 : charsLeft;
      return Math.min(max, charsLeft);
    }

    saveAsDefault() {
      if(!this.BOD_2262){
        this.saving = true;
        this.MedicationService
          // .updateLemonaidMedication(this.medication.id, this.medication)
          .updateLemonaidMedication(this.medication.medication_id, this.medication)
          .catch((err) => {
            this.Utils.createErrorToast(err, 'Failed to save medication.');
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }

    onDosespotMedicationFound(medication) {
      this.dosespotMedication = medication;
    }

    canPairDosespotMedication() {
      this.scheduleError = null;

      if (this.dosespotMedication) {
        const { schedule } = this.dosespotMedication;

        switch (schedule) {
          case '2':
          case '3':
          case '4':
          case '5':
            this.scheduleError = 'You may not prescribe controlled substances. Please choose another medicine.';
            return false;
          default:
            return true;
        }
      }

      return false;
    }

    pairDosespotMedication(dosespotMedication) {
      // this.MedicationService.updateLemonaidMedication(this.medication.id, { dosespot_medication: dosespotMedication })
      this.MedicationService.updateLemonaidMedication(this.medication.medication_id, { dosespot_medication: dosespotMedication })
      .then(() => {
        this.medication.dosespot_medication = dosespotMedication;
        this.medication.order_line_medication_id = null;
      })
      .catch((err) => {
        this.Utils.createErrorToast(err, 'Failed to update Medication');
      });
    }

    removeDosespotMedication() {
      // this.MedicationService.updateLemonaidMedication(this.medication.id, { dosespot_medication: {} })
      this.MedicationService.updateLemonaidMedication(this.medication.medication_id, { dosespot_medication: {} })
      .then(() => {
        this.medication.dosespot_medication = this.dosespotMedication = null;
      })
      .catch((err) => {
        this.Utils.createErrorToast(err, 'Failed to update Medication');
      });

      // We added this endpoint call as Greg requested on:
      // https://app.asana.com/0/333364685358613/663153276048623
      // MedicationService.updateLemonaidMedication and MedicationService.removePrescription
      // are NOT related so we make both API calls separately

      if (this.medication.order_line_medication_id) {
        this.MedicationService.removePrescription(this.visitid, this.medication.order_line_medication_id)
        .then(() => {

        })
        .catch((err) => {
          this.Utils.createErrorToast(err, 'Failed to remove the Prescription');
        });
      }
    }

    getBadgeText() {
      const { saved, sent, remote_status, dosespot_transmission_errors } = this.medication;

      // if we have saved the prescription to the orderline but have not yet created
      // or sent the prescription, tell the doctor the prescription is ready
      if (saved && !sent && !remote_status) {
        return 'Ready To Send';
      }

      // If we have a transmission error, but we have ignored the error,
      // show the last error's acknowledgment_type
      if (
        remote_status === 'Error' &&
          Array.isArray(dosespot_transmission_errors) &&
          dosespot_transmission_errors.length &&
          !this.hasUnacknowledgedTransmissionErrors()
      ) {
        // we can assume this key is not null
        return dosespot_transmission_errors[0].acknowledgment_type;
      }

      return remote_status;
    }

    getBadgeType() {
      const text = this.getBadgeText();

      switch (text) {
        case 'Ready To Send':
          return 'default';
        case 'ignore':
        case 'print':
          return 'warning';
        case 'Error':
          return 'alert';
        case 'PharmacyVerified':
          return 'pharmacy-verified';
        case 'eRxSent':
          return 'success';
        case 'Sending':
          return 'info';
        default:
          return 'default';
      }
    }

    getLastTransmissionError() {
      return this.medication.dosespot_transmission_errors[0];
    }

    /**
     * Determines if a doctor needs to attend to any transmission errors
     * @returns {boolean}
     */
    hasUnacknowledgedTransmissionErrors() {
      const { dosespot_transmission_errors: transmissionErrors } = this.medication;

      return transmissionErrors && transmissionErrors.some(err => !err.acknowledgment_type);
    }

    updateTransmissionError(type) {
      this[`${type}Loading`] = true;
      const lastTransmissionError = this.getLastTransmissionError();

      this.Orders
        .updateTransmissionError(lastTransmissionError.id, type)
        .then(() => {
          lastTransmissionError.acknowledgment_type = type;
        })
        .catch((err) => {
          this.Utils.createErrorToast(err, 'Failed to update transmission error.');
        })
        .finally(() => {
          this[`${type}Loading`] = false;
        });
    }

    openPharmacyDialog() {
      let autoRefillTab = false;

      this.Pharmacy.openSearchDialog(this.patient.address, autoRefillTab)
        .then((pharmacy) => {
          if (!pharmacy) {
            return;
          }
          this.medication.pharmacy = pharmacy;
        });
    }

    searchPharmacy() {

      var fulfilment_type = this.Orders.getFulfilmentType(this.pharmacyOption);

      if (fulfilment_type === 0 || fulfilment_type === 4) {

        // Pickup only visit
        // Show pharmacy search popup
        this.openPharmacyDialog();

      } else {

        // For one time: mailorderOnly is true => we do NOT show "Search for another pharmacy" button
        // For recurring: mailorderOnly is true => we do NOT show "Search for another pharmacy" button
        // For hybrid: mailorderOnly is false => we SHOW "Search for another pharmacy" button

        var isMailorderOnly = this.Orders.isFulfilmentTypeMailorderOnly(fulfilment_type);

        this.Pharmacy.getMailorderPharmacy(this.medication.medication_id, this.visitState)
        .then(({ data }) => {

          var mailorderPharmacy = data;

          if (mailorderPharmacy && mailorderPharmacy.id) {

            // Mailorder pharmacy found
            // Show mailorder pharmacy confirmation popup
            this.Pharmacy.confirmMailorderPharmacy(isMailorderOnly, mailorderPharmacy, this.medication, this.visitState, (response) => {

              if (response) {

                if (response.mailorder) {

                  // User confirms mailorder pharmacy
                  this.medication.pharmacy = mailorderPharmacy;

                } else {

                  // User chooses to search for another pharmacy
                  this.openPharmacyDialog();
                }

              } else {

                // Do nothing
                // If user closes the popup
              }
            });

          } else {

            // Mailorder pharmacy not found
            // Show pharmacy search popup
            this.openPharmacyDialog();
          }
        })
        .catch((err) => {

          // Mailorder pharmacy not found
          // Show pharmacy search popup
          this.openPharmacyDialog();
        });
      }
    }
  }

  PrescriptionEditorController.$inject = ["$scope", "toastr", "Constants", "Orders", "MedicationService", "Utils", "Pharmacy", "Services"];
  angular
    .module('pims')
    .component('prescriptionEditor', {
      templateUrl: 'app/components/prescription-editor/prescription-editor.html',
      controller: PrescriptionEditorController,
      bindings: {
        medication: '=',
        visitid: '=',
        visitState: '=',
        pharmacyOption: '=',
        canRemove: '<',
        onRemove: '&',
        visitIsRejected: '&',
        visitIsLocked: '&',
        pharmacyTaskPending: '=',
        confirmPharmacyTask: '&',
        patient: '=',
        service: '=',
        onSave: '&'
      },
    });
})();
